export default __webpack_public_path__ + "static/media/Group 3350.614388f9.png";